import { Flex, Text } from '@chakra-ui/react'
import Link from 'next/link'
import React from 'react'

export const BreadCrumb = ({ from, to }) => {
    return (
        (<Flex flexDir={"row"} alignItems={"center"} my={["20px", "48px"]}>
            <Link href={"/who-we-help"}>

                <Text color={"gray.500"} fontWeight={"500"}>{from || "Who we help"} /</Text>

            </Link>
            <Text color={"brand.800"}>{to}</Text>
        </Flex>)
    );
}